export const PREVIEW_ENTITY_ID_PROP = {
	type: Number,
	required: true,
}

export const PREVIEW_QUERY_PAYLOAD_PROP = {
	type: Object,
	default: () => ({}),
}

export const PREVIEW_PREVIEW_CONTEXT_PROP = {
	type: Object,
}

export const DEFAULT_PREVIEW_PROPS = {
	entityId: PREVIEW_ENTITY_ID_PROP,
	queryPayload: PREVIEW_QUERY_PAYLOAD_PROP,
	previewContext: PREVIEW_PREVIEW_CONTEXT_PROP,
}

export const DEFAULT_PREVIEW_EMITS = {
	/**
	 * @description Вызывается когда была обновлена сущность (например через формы которые подключаются прямо в превью). Payload: { entityId, ?entity }
	 */
	'update:entity': null,
}

const PREVIEW_SECTION_TYPES = {
	ADVANCED_LIST: 'advancedList',
}

Object.freeze(PREVIEW_SECTION_TYPES)

export {
	PREVIEW_SECTION_TYPES,
}
